<template lang="pug">
//- client-only
div.items-center.flex
  .log-in(v-if="buttonStyle === 'ghost'")
    button(type="button" @click="showSignup") {{ props.text || $t('header.login') }}
  .sign-up(v-else)
    Button(@click="showSignup") {{ props.text || $t('login.signup_button') }}
  //- client-only
  SignupLoginModal(v-model="signModalVisible" :defaultState="props.defaultState")
</template>

<script lang="ts" setup>
import { toast } from '~/utils/sonner'
const signModalVisible = ref(false)
const session = useVisitorSession()
const { t } = useI18n()

const props = defineProps<{
  defaultState: 'login' | 'signup' | 'reset'
  buttonStyle?: 'ghost' | 'main'
  text?: string
  redirectIfLoggedIn?: boolean
}>()

function showSignup() {
  if (props.redirectIfLoggedIn && session.loggedIn) {
    toast({
      title: t('login.already_logged_in'),
      duration: 1000,
    })
    return navigateTo(`/dashboard/${session.id}`)
  }
  signModalVisible.value = true
}

const buttonStyle = computed(() => {
  if (!props.buttonStyle) {
    return props.defaultState === 'login' ? 'ghost' : 'main'
  }
  return props.buttonStyle
})

defineExpose({
  showSignup
})
</script>

<style lang="postcss" scoped>
.sign-up {
  font-family: 'Metropolis', sans-serif;
  font-weight: 600;
  text-decoration: none;
  margin: 16px 0 16px;
  transition: all 0.5s ease-out;

  button {
    background-color: var(--signup-bg);
    box-shadow: 8px 8px 0 var(--signup-shadow);
    /* background-color: #ffffff; */
    cursor: pointer;
    border: solid 2px var(--signup-border);
    /* box-shadow: 8px 8px 0 var(--purple); */
    /* font-family: "Metropolis", sans-serif; */
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    padding: 28px 32px;
    position: relative;
    transition: background-color 0.15s ease, color 0.15s ease;

    /* -webkit-appearance: none; */
    /* -moz-appearance: none; */
    &:hover {
      background-color: #ffffff;
      color: #000000 !important;
      /* span {
      } */
      border-color: #000000;
    }

    /* span {
    } */
    color: var(--signup-color) !important;
  }
}

.log-in {
  &:hover {
    &::after {
      visibility: hidden;
    }
  }

  button {
    border: 1px solid red;
    border-radius: 4px;
    padding: 4px 22px;
    color: var(--button-text);
    border: solid 2px var(--button-text);
    font-weight: 700;
    transition: background-color 0.15s ease, color 0.15s ease;

    @media (max-width: 768px) {
      padding: 4px 12px;
    }

    &:hover {
      background: var(--button-text);
      color: var(--button-bg);
      border-color: var(--button-bg);
      border-radius: 4px;
    }
  }
}
</style>
